import { render, staticRenderFns } from "./OnePager.vue?vue&type=template&id=09aabdb8&scoped=true&"
import script from "./OnePager.vue?vue&type=script&lang=js&"
export * from "./OnePager.vue?vue&type=script&lang=js&"
import style0 from "./OnePager.vue?vue&type=style&index=0&id=09aabdb8&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aabdb8",
  null
  
)

export default component.exports